<template>
  <v-content>
    <v-container class="fill-height azul" fluid>
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12 py-1">
            <v-img
              height="77"
              src="@/assets/images/logo.png"
              class="ma-5 pa-5"
              contain
            ></v-img>
            <v-toolbar color="#1B6BAA" dark flat>
              <v-toolbar-title>Forgot Password</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert
                v-if="successMessage"
                type="success"
                dismissible
                class="mb-4"
              >
                {{ successMessage }}
              </v-alert>
              <v-form>
                <p class="mb-3 text-body-2">
                  Enter your email address and we'll send you a link to reset
                  your password.
                </p>
                <v-text-field
                  label="Email"
                  name="email"
                  prepend-icon="mdi-email"
                  type="email"
                  v-model="email"
                  :disabled="loading"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" to="/login" :disabled="loading">
                <v-icon left>mdi-arrow-left</v-icon>
                Back to Login
              </v-btn>
              <v-spacer />
              <v-btn
                color="primary"
                @click="sendResetLink"
                :loading="loading"
                :disabled="loading || !email"
              >
                Send Reset Link
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<style scoped>
.azul {
  background: #1b6baa;
}
</style>

<script>
export default {
  data: () => ({
    email: "",
    loading: false,
    successMessage: "",
  }),
  methods: {
    sendResetLink: function() {
      var este = this;
      este.loading = true;
      este.successMessage = "";

      var variables = {
        email: este.email,
      };

      este.$http
        .post(este.$api + "forgotPassword", variables)
        .then(function(response) {
          window.console.log(response);
          if (response.status == 200 && response.data.status == "ok") {
            este.successMessage =
              "If the email exists in our system, you will receive a password reset link shortly. Please check your inbox.";
            este.email = "";
          } else {
            var mensaje = {
              color: "info",
              timeout: 5000,
              message:
                "If the email exists in our system, you will receive a password reset link shortly.",
            };
            este.$store.commit("msgMuestra", mensaje);
          }
          este.loading = false;
        })
        .catch(function(err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "An error occurred. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
          este.loading = false;
        });
    },
  },
  mounted: function() {
    if (this.$store.getters.token) {
      this.$router.push("/");
    }
  },
};
</script>
